<template>
<div>
    <div v-if="buttonTop" class="mb-3">
        <b-button v-if="checkUserPermission('ontslagbrief', 'can_add')" @click="addNew = !addNew" :variant="addNew ? 'danger' : 'primary'"><i :class="[addNew ? 'fa-solid fa-ban' : 'fa-solid fa-plus']"></i> {{ addNew ? 'Cancel' : 'Add' }}</b-button>
        <b-collapse id="add" v-model="addNew" variant="primary">
            <OntslagbriefForm class="mt-3" :callback="callback" :small="small" @created="addNew = false" :refresh="addNew" />
        </b-collapse>
    </div>
    <b-overlay :show="confirm" no-wrap @shown="onShown">
        <template #overlay>
            <div ref="dialog" tabindex="-1" role="dialog" aria-modal="false" aria-labelledby="form-confirm-label">
                <p class="text-center">
                    <i class="fa-light fa-xmark text-danger"></i> <strong class="text-danger">DELETE ONTSLAGBRIEF ON {{ toLocaleDate(selected?.created) }} </strong>
                </p>
                <div class="text-center">
                    <b-button variant="outline-danger" class="mr-3" @click="onCancel">Cancel</b-button>
                    <b-button variant="outline-success" @click="onConfirmed(selected)">Confirm</b-button>
                </div>
            </div>
        </template>
    </b-overlay>
    <b-overlay
        :show="$store.getters['loading/isLoading']('ontslagbrief')"
        rounded="sm"
        variant="light"
        spinner-variant="dark"
        :opacity="0.80"
        blur="2px">
        <b-card-body class="p-0">
            <b-table
                ref="table"
                class="m-0"
                responsive
                stacked="sm"
                show-empty
                striped
                hover
                :fixed="fixed"
                :small="small"
                :borderless="borderless"
                primary-key="id"
                :current-page="currentPage"
                :per-page="perPage"
                :items="items"
                :fields="fields"
                :no-sort-reset="true"
                :sort-by.sync="sortedBy"
                :sort-desc.sync="sortedDesc"
                :no-border-collapse="false">

                <template v-slot:cell(patient_name)="data">
                    <span :class="{ 'small font-italic text-muted': !data.value }">{{ data.value || 'n/a' }} </span>
                </template>

                <template v-slot:cell(actions)="row">
                    <b-button-group size="sm">
                        <b-button v-if="checkUserPermission('ontslagbrief', 'can_execute')" variant="secondary" v-b-tooltip.hover title="Print" @click="printRow(row)"><i class="fa-solid fa-print"></i></b-button>

                        <b-button variant="primary" @click="row.toggleDetails"><i class="fa-solid fa-ellipsis-h"></i></b-button>
                        <b-button v-if="checkUserPermission('ontslagbrief', 'can_delete')" variant="danger" @click="onRemoveItem(row.item)"><i class="fa-light fa-xmark"></i></b-button>
                    </b-button-group>
                </template>

                <template #row-details="row">
                    <b-list-group flush>
                        <b-list-group-item><strong>Aan:</strong> {{ row.item.addressed_to || 'n/a' }}</b-list-group-item>
                        <b-list-group-item><strong>Bevallen op/om:</strong> {{ row.item.delivery_date || 'n/a' }} {{ row.item.delivery_time || '' }} ({{ row.item.child_gender || 'n/a' }}, {{ row.item.gestation_weeks || 'n/a' }} wkn)</b-list-group-item>
                        <b-list-group-item><strong>G/P/Ab/M:</strong> {{ row.item.gravida || '-' }}/{{ row.item.para || '-' }}/{{ row.item.abortion || '-' }}/{{ row.item.miscarriage || '-' }}</b-list-group-item>
                        <b-list-group-item><strong>Bijzonderheden:</strong> {{ row.item.delivery_notes || 'n/a' }}</b-list-group-item>
                        <b-list-group-item><strong>Verlosk:</strong> {{ row.item.midwife || 'n/a' }}</b-list-group-item>
                    </b-list-group>
                </template>

                <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>

                <template v-slot:empty="scope">
                    <div class="small text-muted text-center my-2">
                        <span>n/a</span>
                    </div>
                </template>
                <template v-slot:custom-foot="scope">
                    <b-tr class="border-top">
                        <b-td colspan="1" class="align-middle" variant="light" style="background: #fff;">
                            Showing {{ startIndex }} to {{ endIndex }} of {{ totalRows }}
                        </b-td>
                        <b-td colspan="1" class="text-right align-middle" variant="light" style="background: #fff;">
                            <b-pagination class="m-0" prev-text="Prev" next-text="Next" hide-goto-end-buttons align="right" :total-rows="totalRows" v-model="currentPage" :per-page="perPage" />
                        </b-td>
                    </b-tr>
                </template>
            </b-table>
            <b-card-footer v-if="!buttonTop">
                <b-button v-if="checkUserPermission('ontslagbrief', 'can_add')" @click="addNew = !addNew" :variant="addNew ? 'danger' : 'primary'"><i :class="[addNew ? 'fa-solid fa-ban' : 'fa-solid fa-plus']"></i> {{ addNew ? 'Cancel' : 'Add' }}</b-button>
                <b-collapse id="add" v-model="addNew" variant="primary">
                    <OntslagbriefForm class="mt-3" :callback="callback" :small="small" @created="addNew = false" :refresh="addNew"/>
                </b-collapse>
            </b-card-footer>
        </b-card-body>
    </b-overlay>
</div>
</template>
<script>
import ComponentBaseExtension from "@/core/components/ComponentBaseExtension"
import { mapGetters, mapActions } from "vuex"

import OntslagbriefForm from './OntslagbriefForm'

import printJS from 'print-js'
import cloneDeep from 'lodash/cloneDeep'

export default ComponentBaseExtension.extend({
    name: "ontslagbrief-base",
    components: {
        OntslagbriefForm
    },
    data() {
        return {
            addNew: false,
            fields: [
                { key: 'ontslagbrief_date', label: 'Date/Time', class: {"align-middle" : true, "small": this.small }, formatter: (value) => this.toLocaleDate(value) },
                { key: 'patient_name', label: 'Patiënte', class: {"align-middle" : true, "small": this.small } },
                { key: "actions", label: "", class: {"align-middle" : true, "text-right": true, "small": this.small } },
            ],

            currentPage: 1,
            perPage: 5,
            sortedBy: 'ontslagbrief_date',
            sortedDesc: true,

            confirm: false,
            selected: null,
        }
    },
    computed: {
        ...mapGetters('health', ['getPatientOntslagbrief']),
        items() {
            return cloneDeep(this.getPatientOntslagbrief())
        },
        totalRows() {
            return this.items.length
        },
        startIndex() {
            return (this.currentPage - 1) * this.perPage + 1
        },
        endIndex() {
            var end = this.totalRows
            if (this.perPage < this.totalRows) {
                end = this.perPage * this.currentPage
                if (end > this.totalRows) {
                    end = this.totalRows
                }
            }
            return end
        }
    },
    methods: {
        ...mapActions('health', ['getOntslagbriefForCurrentPatient', 'deletePatientOntslagbrief', 'ontslagbriefToHTMLById']),
        async loadForPatient(patient) {
            await this.getOntslagbriefForCurrentPatient()
        },
        async printRow(row) {
            const ontslagbrief = await this.ontslagbriefToHTMLById(row.item.id)
            printJS({
                printable: ontslagbrief,
                type: 'raw-html'
            })
        },
        onRemoveItem(item) {
            this.confirm = true
            this.selected = item
        },
        onConfirmed(item) {
            this.deletePatientOntslagbrief(item.id).then(() => {
                this.notify("Ontslagbrief removed", "Ontslagbrief was removed successfully")
                this.confirm = false
                this.processing = false
                this.selected = null
            })
            .catch(errors => {
                this.notify("Error", "Something went wrong", 'danger')
                this.confirm = false
                this.selected = null
            })
        },
        onShown() {
            this.$refs.dialog?.focus()
        },
        onCancel() {
            this.confirm = false
            this.selected = null
        }
    }
})
</script>
